import { motion } from 'motion/react';
import type { Ref } from 'react';

import Button, { ButtonSize } from '@/components/BaseLibrary/Button/Button';
import { useSunrunShopActions } from '@/data-store/hooks/useSunrunShopStore';
import useViewPortSize from '@/hooks/useViewportSize';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './Cart.styles';
import CartHeader from './CartHeader';

export default function EmptyCart({ ref }: { ref?: Ref<HTMLDivElement> }) {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { isExtraSmall } = useViewPortSize();
  const { setIsCartOpen } = useSunrunShopActions();

  const closeCart = () => setIsCartOpen(false);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9, transition: { duration: 0 } }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
    >
      <div className={classes.container}>
        <CartHeader mode='empty' />
        <div className={classes.divider} />
        <div className={cx(classes.emptyCartText, globalClasses.h3)}>
          Your Cart is Empty
        </div>
        <Button
          onClick={closeCart}
          label='Continue shopping'
          size={isExtraSmall ? ButtonSize.SM : ButtonSize.MD}
          className={classes.continueShoppingButton}
        />
      </div>
    </motion.div>
  );
}
